/** The error envelope every non-2xx api response carries. */
export interface ApiErrorEnvelope {
	error: { code: string; message: string; details?: Record<string, string[]> };
}

/** A failed api call, carrying the envelope's code/message/details + HTTP status. */
export class ApiError extends Error {
	readonly status: number;
	readonly code: string;
	readonly details?: Record<string, string[]>;

	constructor(status: number, envelope?: ApiErrorEnvelope) {
		super(envelope?.error?.message ?? 'Request failed');
		this.name = 'ApiError';
		this.status = status;
		this.code = envelope?.error?.code ?? 'ERROR';
		this.details = envelope?.error?.details;
	}
}

/**
 * Turn an openapi-fetch result into its data, or throw an ApiError so React
 * Query (and the global onError) see the failure. Gate on the HTTP status, not
 * `error`: an empty-bodied failure (a proxy 502/504) leaves `error` undefined.
 */
export function unwrap<T>(result: { data?: T; error?: unknown; response: Response }): T {
	if (!result.response.ok) {
		throw new ApiError(result.response.status, result.error as ApiErrorEnvelope | undefined);
	}
	return result.data as T;
}
